import { render, staticRenderFns } from "./teacherPartner.vue?vue&type=template&id=0839a81a&scoped=true"
import script from "./teacherPartner.vue?vue&type=script&lang=js"
export * from "./teacherPartner.vue?vue&type=script&lang=js"
import style0 from "./teacherPartner.vue?vue&type=style&index=0&id=0839a81a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0839a81a",
  null
  
)

export default component.exports